import { createAsyncThunk } from '@reduxjs/toolkit';
import { CancelledOrdersAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import {
  ICancelledOrdersListQuery,
  ICancelledOrdersQuery,
  IGetCancelledOrdersResponse,
  IGetCancelledPartnersResponse,
  IGetCancelledReasonsResponse,
} from '@/models/cancelledOrders.model';
import { CANCELLED_ORDERS_SLICE_NAME } from './models';
import {
  getMockCancelledOrdersData,
  getMockCancelledPartnersResponse,
  getMockCancelledReasonsResponse,
} from '../helpers';

export const getCancelledOrdersData = createAsyncThunk<
  IGetCancelledOrdersResponse,
  ICancelledOrdersQuery,
  { serializedErrorType: IApiError }
>(
  `${CANCELLED_ORDERS_SLICE_NAME}/getCancelledOrdersData`,
  async (params) => {
    try {
      const response = await CancelledOrdersAPI.getCancelledOrders(params);
      return response.data;
    } catch {
      return { data: getMockCancelledOrdersData(params) };
    }
  },
  { serializeError: formatApiError },
);

export const getCancelledReasonsList = createAsyncThunk<
  IGetCancelledReasonsResponse,
  ICancelledOrdersListQuery,
  { serializedErrorType: IApiError }
>(
  `${CANCELLED_ORDERS_SLICE_NAME}/getCancelledReasonsList`,
  async (params) => {
    try {
      const response = await CancelledOrdersAPI.getCancelledReasons(params);
      return response.data;
    } catch {
      return getMockCancelledReasonsResponse(params.page, params.per_page);
    }
  },
  { serializeError: formatApiError },
);

export const getCancelledPartnersList = createAsyncThunk<
  IGetCancelledPartnersResponse,
  ICancelledOrdersListQuery,
  { serializedErrorType: IApiError }
>(
  `${CANCELLED_ORDERS_SLICE_NAME}/getCancelledPartnersList`,
  async (params) => {
    try {
      const response = await CancelledOrdersAPI.getCancelledPartners(params);
      return response.data;
    } catch {
      return getMockCancelledPartnersResponse(params.page, params.per_page);
    }
  },
  { serializeError: formatApiError },
);
